import React from 'react';
import { Box, Chip, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OnboardingState } from '../onboarding.types';

interface Step6Props {
  state: OnboardingState;
}

const Step6_Review: React.FC<Step6Props> = ({ state }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t('onboarding.step_review')}
      </Typography>

      <Typography variant="subtitle1" fontWeight={600} mt={2}>
        {t('onboarding.step_school_profile')}
      </Typography>
      {state.school ? (
        <List dense>
          <ListItem>
            <ListItemText primary={t('school_name_label')} secondary={(state.school as any).name} />
          </ListItem>
        </List>
      ) : (
        <Chip label="Not set" color="warning" size="small" />
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" fontWeight={600}>
        {t('onboarding.step_academic_terms')}
      </Typography>
      {state.terms.length > 0 ? (
        <List dense>
          {state.terms.map((term, i) => (
            <ListItem key={i}>
              <ListItemText primary={term.term} secondary={term.status} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Chip label="Not set" color="warning" size="small" />
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" fontWeight={600}>
        {t('onboarding.step_classrooms')}
      </Typography>
      {state.classrooms.length > 0 ? (
        <List dense>
          {state.classrooms.map((c, i) => (
            <ListItem key={i}>
              <ListItemText primary={c.name} secondary={`Capacity: ${c.capacity}`} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Chip label="Not set" color="warning" size="small" />
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" fontWeight={600}>
        {t('onboarding.step_admin_accounts')}
      </Typography>
      {state.admins.length > 0 ? (
        <List dense>
          {state.admins.map((admin, i) => (
            <ListItem key={i}>
              <ListItemText
                primary={`${admin.firstName} ${admin.lastName}`}
                secondary={admin.email}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Chip label="Not set" color="warning" size="small" />
      )}
    </Box>
  );
};

export default Step6_Review;
